/**
 * The AttentionInput both wallboards build from a WallboardStore (the web
 * dashboard and Ryn's Roost mobile), so a new alert source is wired once
 * (WI 34807; it was a copied block in each component).
 */
import type {
  AccountSignal,
  AttentionInput,
  HostSignal,
  SeatSignal,
} from './attention.logic';
import { buildDaemonSummary } from './daemons.logic';
import { buildUnansweredInbounds } from './wallboard.logic';
import type { WallboardStore } from './wallboard-store';

export type AttentionStore = Pick<
  WallboardStore,
  | 'seats'
  | 'retiredSeats'
  | 'desiredRoster'
  | 'hostDaemons'
  | 'owedOccurrences'
  | 'contextSnapshots'
  | 'now'
>;

/** `withSessions`: the waiting rows' terminal links (web only, WI 34335). */
export function storeAttentionInput(
  data: AttentionStore,
  signals: {
    seats: SeatSignal[];
    hosts: HostSignal[];
    accounts: AccountSignal[];
  },
  withSessions: boolean
): AttentionInput {
  const now = data.now();
  const rows = data.seats() ?? [];
  return {
    ...signals,
    waiting: buildUnansweredInbounds(rows, now),
    daemons: buildDaemonSummary(data.hostDaemons(), now).rows,
    deadSeats: rows,
    desiredRoster: data.desiredRoster() ?? [],
    retiredSeats: data.retiredSeats() ?? [],
    owed: data.owedOccurrences() ?? [],
    ...(withSessions ? { sessions: data.contextSnapshots() } : {}),
  };
}
